import { render, staticRenderFns } from "./Feriados.vue?vue&type=template&id=b5dc9e14&scoped=true"
import script from "./Feriados.vue?vue&type=script&lang=js"
export * from "./Feriados.vue?vue&type=script&lang=js"
import style0 from "./Feriados.vue?vue&type=style&index=0&id=b5dc9e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc9e14",
  null
  
)

export default component.exports